<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2022-02-12 21:09:38
 * @LastEditTime: 2022-04-24 23:42:57
 * @FilePath: \raacfold\src\components\laside\SelectedSurfaceSetting.vue
-->
<template>
        <table class="bm-table">
            <tr>
                <td class="bm-structure-table-name">Surface Type</td>
                <td class="bm-table-ope">
                    <el-select v-model="surface_type" placeholder="Select item">
                        <el-option v-for="item in options_surface_type" :key="item.value" :value="item.value">
                        </el-option>
                    </el-select>
                </td>
            </tr>
            <tr>
                <td class="bm-structure-table-name">Opacity</td>
                <td class="bm-table-ope">
                    <el-slider style="margin: 0 12px 0 12px" v-model="surface_opacity" :step="0.01" :max="1">
                    </el-slider>
                </td>
            </tr>

            <tr>
                <td class="bm-structure-table-name">Show Side</td>
                <td class="bm-table-ope">
                    <el-select v-model="surface_side" placeholder="Select item">
                        <el-option v-for="item in options_surface_side" :key="item.value" :value="item.value">
                        </el-option>
                    </el-select>
                </td>
            </tr>
            <tr>
                <td class="bm-structure-table-name">Smooth</td>
                <td class="bm-table-ope">
                    <el-slider style="margin: 0 12px 0 12px" v-model="surface_smooth" :step="1" :max="20"></el-slider>
                </td>
            </tr>
            <tr>
                <td class="bm-structure-table-name">Roughness</td>
                <td class="bm-table-ope">
                    <el-slider style="margin: 0 12px 0 12px" v-model="surface_roughness" :step="0.01" :max="1">
                    </el-slider>
                </td>
            </tr>
            <tr>
                <td class="bm-structure-table-name">Shadow</td>
                <td class="bm-table-ope">
                    <el-slider style="margin: 0 12px 0 12px" v-model="surface_metalness" :step="0.01" :max="1">
                    </el-slider>
                </td>
            </tr>
            <tr>
                <td class="bm-structure-table-name">Probe Radius</td>
                <td class="bm-table-ope">
                    <el-slider style="margin: 0 12px 0 12px" v-model="surface_probe_radius" :step="1" :max="20">
                    </el-slider>
                </td>
            </tr>
            <tr>
                <td class="bm-structure-table-name">Scale Factor</td>
                <td class="bm-table-ope">
                    <el-slider style="margin: 0 12px 0 12px" v-model="surface_scale_factor" :step="1" :max="5">
                    </el-slider>
                </td>
            </tr>
            <tr>
                <td class="bm-structure-table-name">Contour</td>
                <td class="bm-table-ope">
                    <el-switch v-model="surface_contour" active-color="#a4b0be" inactive-color="#E4E7ED"></el-switch>
                </td>
            </tr>
            <tr>
                <td class="bm-structure-table-name">Flat Shaded</td>
                <td class="bm-table-ope">
                    <el-switch v-model="surface_flat_shaded" active-color="#a4b0be" inactive-color="#E4E7ED">
                    </el-switch>
                </td>
            </tr>
        </table>
</template>

<script>
    export default {
        name: "StructureSetting",
        data() {
            return {
                surface_visual: true,
                winHeight: 320 + "px",
                global_color: "",
                surface_color: "",
                selection_color: "",
                global_background: "#FFFFFF",
                global_structure_representation: "Cartoon",
                selection_structure_representation: "Licorice",
                options_structure_representation: [{
                        value: "Cartoon",
                    },
                    {
                        value: "Ribbon",
                    },
                    {
                        value: "Rope",
                    },
                    {
                        value: "Tube",
                    },
                    {
                        value: "Trace",
                    },
                    {
                        value: "Ball+stick",
                    },
                    {
                        value: "Hyperball",
                    },
                    {
                        value: "Licorice",
                    },
                    {
                        value: "Line",
                    },
                    {
                        value: "Point",
                    },
                    {
                        value: "Backbone",
                    },
                    {
                        value: "Spacefill",
                    },
                    {
                        value: "Surface",
                    },
                    {
                        value: "Transparent",
                    },
                ],
                surface_type: "av",
                options_surface_type: [{
                        value: "vws",
                    },
                    {
                        value: "sas",
                    },
                    {
                        value: "ms",
                    },
                    {
                        value: "av",
                    },
                ],
                surface_smooth: 20,
                surface_opacity: 1,
                surface_flat_shaded: false,
                surface_roughness: 1,
                surface_metalness: 0,
                surface_probe_radius: 1.5,
                surface_scale_factor: 2,
                surface_side: "Front",
                surface_contour: false,
                surface_low_resolution: false,
                options_surface_side: [{
                        value: "Front",
                    },
                    {
                        value: "Back",
                    },
                    {
                        value: "Double",
                    },
                    // {'value': 'Select'},
                ],
                shape_map: {
                    Cartoon: "icon-font icon-cartoon",
                    Ribbon: "icon-font icon-bianzu3",
                    Rope: "icon-font icon-rope1",
                    Tube: "icon-font icon-tube",
                    Trace: "icon-font icon-trace",
                    "Ball+stick": "icon-font icon-danbaizhi",
                    Hyperball: "icon-font icon-jiaohu",
                    Licorice: "icon-font icon-lianjie",
                    Line: "icon-font icon-icon-",
                    Point: "icon-font icon-xian1",
                    Backbone: "icon-font icon-buguize",
                    Spacefill: "icon-font icon-spacefill",
                    Surface: "icon-font icon-bingdu",
                    Transparent: "el-icon-close",
                },
                shape_class: "icon-font icon-cartoon",
                predefineColors: [
                    "#ff4500",
                    "#ff8c00",
                    "#ffd700",
                    "#90ee90",
                    "#00ced1",
                    "#1e90ff",
                    "#c71585",
                ],
                selected_effect: "Double",
                options_selected_effect: [{
                        value: "Double",
                    },
                    {
                        value: "Surface",
                    },
                    {
                        value: "Current selected representation",
                    },
                ],
                selected_focus: false,
                global_focus: false,
                global_animation: false,
            };
        },
        watch: {
            "$store.state.left_aside_width"(val) {
                this.switch_width = val;
            },
            surface_visual() {
                this.update_surface_setting();
            },
            surface_type() {
                this.update_surface_setting();
            },
            surface_color() {
                this.update_surface_setting();
            },
            surface_opacity() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.update_surface_setting();
                }, 300);
            },
            surface_contour() {
                this.update_surface_setting();
            },
            surface_side() {
                this.update_surface_setting();
            },
            surface_smooth() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.update_surface_setting();
                }, 300);
            },
            surface_roughness() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.update_surface_setting();
                }, 300);
            },
            surface_metalness() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.update_surface_setting();
                }, 300);
            },
            surface_probe_radius() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.update_surface_setting();
                }, 300);
            },
            surface_scale_factor() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.update_surface_setting();
                }, 300);
            },
            surface_flat_shaded() {
                this.update_surface_setting();
            },
        },
        mounted() {
            //
            this.init();
        },
        methods: {
            init() {
                this.update_surface_setting();
                
            },
            update_surface_setting() {
                let surface_setting = {
                    surface_visual: this.surface_visual,
                    surface_type: this.surface_type,
                    surface_color: this.surface_color,
                    surface_opacity: this.surface_opacity,
                    surface_contour: this.surface_contour,
                    surface_side: this.surface_side,
                    surface_smooth: this.surface_smooth,
                    surface_roughness: this.surface_roughness,
                    surface_metalness: this.surface_metalness,
                    surface_probe_radius: this.surface_probe_radius,
                    surface_scale_factor: this.surface_scale_factor,
                    surface_flat_shaded: this.surface_flat_shaded,
                };
                this.$store.commit("SelectedSurfaceSettingMutation", surface_setting);
                // console.log("update_surface_setting>>>>>>", this.$store.state.selected_surface_setting);

            },
        },
    };
</script>

<style>
    .bm-table-ope .el-switch.is-checked .el-switch__core {
        border-color: #409eff;
        background-color: #409eff;
    }

    .bm-structure-table-name {
        width: 170px;
        text-align: right;
        background: #dfe4ea;
    }

    .bm-table-ope .el-switch__core {
        margin: 0;
        position: relative;
        width: 180px !important;
        height: 21px !important;
        border: 0px solid #dcdfe6 !important;
        outline: 0;
        border-radius: 0px !important;
        box-sizing: border-box;
        background: #dcdfe6;
        transition: border-color 0.3s, background-color 0.3s;
        vertical-align: middle;
    }

    .bm-table-ope .el-switch {
        margin: 5px 10px 5px 10px;
    }

    .el-switch__core:after {
        content: "";
        position: absolute;
        top: 1px;
        left: 1px;
        border-radius: 0 !important;
        transition: all 0.3s;
        width: 16px !important;
        height: 19px !important;
        background-color: #fff;
    }

    .bm-table-ope .el-color-picker__color-inner {
        border-radius: 0px !important;
    }

    .bm-table-ope .el-color-picker__trigger {
        margin: 5px 0 0 10px !important;
        height: 26px !important;
        width: 200px !important;
        /* padding: 5px 10px 0px 10px; */
        /*border: 1px solid #E0DDD4;*/
        /*border-top: 1px solid #E0DDD4;*/
        /*border-bottom: 1px solid #E0DDD4;*/
    }

    .bm-table-ope .el-color-picker {
        height: 26px !important;
    }

    .bm-table-ope .el-slider__runway {
        width: 100%;
        height: 6px;
        margin: 5px 0;
        background-color: #e4e7ed;
        border-radius: 3px;
        position: relative;
        cursor: pointer;
        vertical-align: middle;
    }

    .bm-table-ope .el-slider__bar {
        height: 6px;
        background-color: #747d8c;
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
        position: absolute;
    }

    .bm-table-ope .el-slider__button {
        width: 16px;
        height: 16px;
        border: 2px solid #747d8c;
        background-color: #fff;
        border-radius: 50%;
        transition: 0.2s;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
</style>